import {
  BaseQueryApi,
  BaseQueryFn,
  FetchArgs,
} from '@reduxjs/toolkit/query/react'
import { msalInstance } from '../..'
import { loginRequest } from '../../authConfig/AuthConfig'
import { authApi, AuthorizedUserResponse } from '../../api/auth/AuthApi'
import { setAtlasData } from '../../redux/reducers/AtlasSandReducer'
import { UI_CONSTANTS } from '../constants/UIConstants'

export const handleMsalReauth = async (
  api: BaseQueryApi,
  args: string | FetchArgs,
  extraOptions: NonNullable<unknown>,
  baseQuery: BaseQueryFn<string | FetchArgs>,
  currentResult: Awaited<ReturnType<BaseQueryFn<string | FetchArgs>>>,
) => {
  const msalResponse = await msalInstance.acquireTokenSilent({
    ...loginRequest,
  })
  if ((msalResponse as Record<string, unknown>)?.error) {
    msalInstance.loginRedirect(loginRequest).catch((e) => {
      console.error('loginRedirect failed:', e)
    })
    return currentResult
  }
  const authResponse: { data?: AuthorizedUserResponse; isSuccess?: boolean } =
    await api.dispatch(
      authApi.endpoints.getAuthorize.initiate(msalResponse.accessToken),
    )
  if (authResponse?.isSuccess) {
    await api.dispatch(
      setAtlasData({
        method: UI_CONSTANTS.AUTHORIZED_USER,
        data: authResponse.data,
      }),
    )
  } else {
    msalInstance.loginRedirect(loginRequest).catch((e) => {
      console.error('loginRedirect failed:', e)
    })
  }
  return await baseQuery(args, api, extraOptions)
}
